import { z } from 'zod';

export const AddToBasketFormSchema = z.object({
  option: z.any().nullable(),
  quantity: z.number().int().min(0),
  amount: z.any().optional(),
  personalization: z.null().optional(),
  product: z.object({ id: z.union([z.string(), z.number()]) }).optional(),
  voucher: z.object({ id: z.union([z.string(), z.number()]) }).optional(),
  event: z.object({ id: z.union([z.string(), z.number()]) }).optional(),
});

export type AddToBasketFormValues = z.infer<typeof AddToBasketFormSchema>;
